export default __webpack_public_path__ + "static/media/AttachmentIcon.57f4863e.svg";